import Button from '@/components/Button'
import Input from '@/components/Input'
import Textarea from '@/components/Textarea'
import Title from '@/components/Title'
import { zheka2 } from '@/images'
import { useCurrentUser, useModal } from '@/hooks'
import { GxForm } from '@garpix/garpix-web-components-react'
import React from 'react'
import style from './styles/feedback.module.scss'
import { useFormik } from 'formik'
import { api } from '@/api'
import ErrorAllText from '@/components/ErrorText/AllErros'
import { feedbackSchema } from '@/utils/schemesFormik'

const Feedback = (): React.ReactElement => {
  const { currentUser } = useCurrentUser()
  const { closeModal } = useModal()

  const formik = useFormik({
    validationSchema: feedbackSchema,
    initialValues: {
      name: currentUser?.name ?? '',
      email: currentUser?.email ?? '',
      question: '',
      apiError: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit (values, { setSubmitting, setErrors, setStatus }) {
      api
        .sendFeedback(values)
        .then(() => {
          setStatus('success')
        })
        .catch((err: any) => {
          setErrors({ apiError: err?.response?.data?.errorText })
          setSubmitting(false)
        })
    }
  })

  const onSubmit = formik.submitForm
  return (
    <div className={style.feedback}>
      {/* Экран 1: Форма */}
      {formik.status !== 'success'
        ? (
          <>
            <Title type='h2' theme='h3' className={style.feedback__title}>
              Задать вопрос
            </Title>

            <p className={style.feedback__text}>
              Заполни все поля и мы ответим тебе в ближайшее время!
            </p>

            <GxForm onGx-submit={onSubmit}>
              <Input
                name='name'
                label='Имя:'
                type='text'
                value={formik.values.name}
                onGx-input={formik.handleChange}
                className={style.feedback__field}
              />
              <Input
                name='email'
                label='Почта:'
                type='email'
                required
                value={formik.values.email}
                onGx-input={formik.handleChange}
                className={style.feedback__field}
                error={formik.errors.email}
              />
              <Textarea
                name='question'
                value={formik.values.question}
                onGx-input={formik.handleChange}
                label='Сообщение:'
                placeholder='Введи свой вопрос'
                required
                className={style.feedback__field}
                error={formik.errors.question}
              />
              {formik.errors.apiError !== ''
                ? (
                  <div>
                    <ErrorAllText text={formik.errors.apiError} />
                  </div>
                  )
                : null}
              <Button
                type='submit'
                disabled={formik.isSubmitting}
                size='large'
                wide
                highlight
                className={style.feedback__submit}
              >
                Отправить
              </Button>
            </GxForm>
          </>
          )
        : (
          <>
            {/* Экран 2: После успешной отправки */}
            <div className={style.success}>
              <div className={style.success_wrap}>
                <Title type='h2' theme='h3' className={style.success__title}>
                  Вопрос отправлен!
                </Title>

                <p className={style.success__text}>
                  В скором времени мы свяжемся с тобой!
                </p>

                <Button
                  type='submit'
                  size='large'
                  theme='secondary'
                  wide
                  highlight
                  className={style.success__submit}
                  onClick={closeModal}
                >
                  Продолжить
                </Button>
              </div>

              <img
                src={zheka2}
                width='272px'
                height='414px'
                alt=''
                className={style.success__image}
              />
            </div>
          </>
          )}
    </div>
  )
}

export default Feedback
